module.exports = __webpack_public_path__ + "img/downhill_line2.f84305cb.svg";